import Service from "../../AuthService";

const Promotion = {
    getPromotion(page) {
        return Service.get("/promotions?page="+page);
    },
    getPromotionAll(data){
        return Service.get(`/promotion-all?product_id=${data.product_id}&sale_id=${data.sale_id}`);
    },
    PromotionAll(){
        return Service.get(`/promotion-all-one-time`);
    },
    showPromotion(id) {
        return Service.get("/promotions/" + id);
    },
    updatePromotion(id, data) {
        return Service.put("/promotions/" + id, data);
    },
    createPromotion(data) {
        return Service.post("/promotions", data);
    },
    deletePromotion(id) {
        return Service.delete("/promotions/" + id);
    },
    getConditionPromotion(){
        return Service.get("/condition-promotion");
    },
    selectAllProducts(data){
        return Service.post("/search-product-promotion",data);
    },
    searchPromotion(data){
        return Service.post("/promotion-search",data);
    }

};

export default Promotion;
